import request from '@/http/request';

// 获取日志文件列表
export function getLogFiles() {
  return request({
    url: '/api/v1/ops/log_files',
    method: 'get',
  });
}

// 获取日志内容（支持关键字搜索）
export function getLogContent(data) {
  return request({
    url: '/api/v1/ops/log_content',
    method: 'post',
    data,
  });
}
